import { render, staticRenderFns } from "./SpeedCard.vue?vue&type=template&id=16abd631&scoped=true&"
import script from "./SpeedCard.vue?vue&type=script&lang=js&"
export * from "./SpeedCard.vue?vue&type=script&lang=js&"
import style0 from "./SpeedCard.vue?vue&type=style&index=0&id=16abd631&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16abd631",
  null
  
)

export default component.exports